<template>
  <div>
    <el-input v-model="formData.showName"
              @click.native="openDialog"
              :size="size"
              :disabled="disabled"
              placeholder="请选择">
      <el-button v-if="disabled == false"
                 @click.stop="clearData"
                 icon="el-icon-close"
                 slot="append">
      </el-button>
    </el-input>

    <esp-el-dialog title="人员选择"
                   width="80%"
                   height="85%"
                   ref="psnDialog"
                   class="esp_psn_dialog"
                   @doAction="doAction">
      <div class="esp_psn_content">
        <div class="esp_psn_head">
          <esp-corp v-model="tabParam.searchParam.pk_corp"
                    @change="corpChange"
                    :disabled="isMustCorp"
                    placeholder="选择公司">
          </esp-corp>
          <el-select v-model="tabParam.searchParam.isSeal"
                     @change="tableReLocad()"
                     placeholder="请选择状态"
                     clearable>
            <el-option key="N" label="启用" value="N"></el-option>
            <el-option key="Y" label="停用" value="Y"></el-option>
          </el-select>
          <el-input v-model="tabParam.searchParam.key"
                    @change="tableReLocad()"
                    placeholder="关键词..." suffix-icon="el-icon-search"
                    clearable>
            <el-button slot="append" icon="el-icon-search" @click="tableReLocad()"></el-button>
          </el-input>
        </div>
        <div class="esp_psn_body">
          <el-table :data="tableData.data"
                    @row-click="rowClick"
                    @row-dblclick="dbClick"
                    @sort-change="sortChange"
                    v-loading="tabParam.showLoading"
                    highlight-current-row stripe
                    height="100%"
                    row-key="pk"
                    size="mini"
                    border
                    stripe>
            <el-table-column label="人员编码" prop="code"></el-table-column>
            <el-table-column label="人员姓名" prop="name"></el-table-column>
            <el-table-column label="部门" prop="deptdoc.name"></el-table-column>
            <el-table-column label="性别" width="70px">
              <template slot-scope="scope">{{ scope.row.sex == 1 ? "男" : "女" }}</template>
            </el-table-column>
            <el-table-column label="状态" width="70px">
              <template slot-scope="scope">
                <div v-if="scope.row.isSeal == 'Y'">停用</div>
                <div v-else style="color: #27B671">启用</div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="esp_psn_footer">
          <el-pagination @size-change="tableSizeChange"
                         @current-change="tableReLocad"
                         :current-page="tabParam.pageNum"
                         :page-sizes="tabParam.pageSizeGroup"
                         :page-size="tabParam.pageSize"
                         :total="tableData.totalRow"
                         layout="total, prev, pager, next, sizes, jumper"
                         background>
          </el-pagination>
        </div>
      </div>
    </esp-el-dialog>
  </div>
</template>

<script>
import * as cache from "@/utils/cache";
import * as psndoc from "@/api/base/psndoc";
import EspCorp from "../corp/EspCorp";

export default {
  name: "EspPsndoc",
  components: {EspCorp},
  data() {
    return {
      formData: {
        showName: "",                   // 显示在输入框中的名称
        selectedData: {}                // 选中的数据
      },

      tableData: {
        totalRow: 0,                                  // 总行数
        data: []                                      // 表格中的数据
      },
      tabParam: {
        showLoading: false,                            // 是否显示加载框
        pageSizeGroup: this.espConstant.esp_page_size_group,    // 每页数量
        pageNum: 1,                                   // 当前页码
        pageSize: this.espConstant.esp_page_size,     // 每页数量
        sortCol: "",                                  // 排序字段下标
        sortType: 1,                                  // 排序方式
        searchParam: {
          pk_deptdoc: null,
          key: "",
          isSeal: "N",
          pk_corp: cache.getDefaultCorpPk()
        }
      }
    }
  },
  props: {
    value: {
      type: String,
      default: ""
    },
    pk_corp: {
      type: String,
    },
    isMustCorp: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: "small"
    }
  },
  methods: {
    /**
     * 开启对话框
     */
    openDialog: function () {
      if (this.disabled == true) {
        return;
      }

      this.tabParam.searchParam = {
        pk_deptdoc: "",
        key: "",
        isSeal: "",
        pk_corp: this.pk_corp
      }

      this.tableReLocad();
      this.$refs.psnDialog.opened();
    },

    /**
     * 公司改变
     */
    corpChange: function () {
      this.tabParam.searchParam.pk_deptdoc = null;
      this.tableReLocad();
    },

    /**
     * 选中行
     */
    rowClick: function (d) {
      this.formData.selectedData = d;
    },

    /**
     * 双击选择
     */
    dbClick: function (row) {
      this.formData.selectedData = row;
      this.$refs.psnDialog.doAction();
    },

    /**
     * 取消选择
     */
    clearData: function () {
      this.formData.showName = "";
      this.$emit("input", null);
      this.$emit("change", null);
    },

    /**
     * 确定选择
     */
    doAction: function (callback) {
      this.formData.showName = this.formData.selectedData.name;
      this.$emit("input", this.formData.selectedData.pk);
      this.$emit("change", this.formData.selectedData.pk);
      this.$emit("afterSelect", this.formData.selectedData);
      callback(true);
    },

    /**
     * 公司必须的时候，这个时候就不能查询人
     */
    tableReLocad: function (val) {
      if (!this.tabParam.searchParam.pk_corp && this.isMustCorp) {
        this.tableData = [];
        return;
      }

      if (val != undefined) {
        this.tabParam.pageNum = val;
      } else {
        this.tabParam.pageNum = 1;
      }

      this.tabParam.showLoading = true;
      psndoc.list(this.tabParam).then(resp => {
        if (resp.data) {
          this.tableData = resp;
        } else {
          this.tableData = {
            totalRow: 0,
            data: []
          }
        }
        this.tabParam.showLoading = false;
      }).catch(error => {
        this.tabParam.showLoading = false;
      });
    },

    /**
     * 排序事件
     */
    sortChange: function (col) {
      if (col.prop) {
        this.tabParam.sortCol = col.prop;
        if (col.order == "descending") {
          this.tabParam.sortType = 2;
        } else {
          this.tabParam.sortType = 1;
        }
        this.tableReLocad();
      }
    },

    /**
     * 每页行数变化事件
     */
    tableSizeChange: function (val) {
      this.tabParam.pageSize = val;
      this.tableReLocad();
    }
  },
  watch: {
    "initData.filterText": function (val) {
      this.$refs.tree.filter(val);
    },
    pk_corp: {
      handler(newVal, oldVal) {
        if (newVal == null && this.isMustCorp == true) {
          this.tabParam.searchParam.pk_corp = "No Corp Data"
        } else {
          this.tabParam.searchParam.pk_corp = newVal
        }
        this.corpChange();
      },
      deep: true,
      immediate: true
    },
    value: {
      handler(newVal, oldVal) {
        this.formData = {showName: "", selectedData: {}};
        if (newVal) {
          psndoc.get(newVal).then(result => {
            if (result.data) {
              this.formData.selectedData = result.data;
              this.formData.showName = result.data.name;
            }
          })
        }
      },
      deep: true,
      immediate: true
    },
    "tabParam.searchParam.pk_corp": function (val) {
      this.$emit("pk_corp", val)
    }
  }
}
</script>

<style lang="less">
.esp_psn_content {
  height: 100%;
  display: flex;
  flex-direction: column;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;

  .esp_psn_head {
    .el-select {
      width: 200px !important;
    }

    .el-input {
      width: 200px !important;
      float: right;
    }
  }

  .esp_psn_body {
    flex: 1;
    padding: 5px 0px;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }

  .esp_psn_footer {
    text-align: right;
  }
}

.esp_psn_dialog {
  &.esp_dialog .el-dialog__body .el-scrollbar__view {
    padding-right: 5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/base/psndoc/EspPsndoc.vue